export class StudyReportingTemplateDropdownResModel {
  TemplateId: number;
  TemplateUid: string;
  TemplateName: string;
  TemplateText: string;
  OrgId: number;
  CreatedBy: number;
  ExamId?: number;
}
